import { Link } from 'react-router-dom';
import logo from '../images/logo_c_only192.png';

function Navbar() {
  return (
    <header className="sticky top-0 z-40 border-b border-border/60 bg-background/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6">
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="The Open Sperm Bank" className="h-8 w-8" />
          <span className="font-display text-xl">The Open Sperm Bank</span>
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2 text-sm">
          <Link to="/" className="rounded-full px-3 py-2 text-muted-foreground hover:text-foreground">Home</Link>
          <Link to="/contact" className="rounded-full px-3 py-2 text-muted-foreground hover:text-foreground">Contact</Link>
          <Link to="/donors" className="rounded-full bg-gradient-to-t from-[#3b82f6] via-[#3b82f6] to-[#60a5fa] px-4 py-2 text-white hover:opacity-90 transition">Find a Donor</Link>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
